if (typeof QuickViewProduct !== "function") {
  class QuickViewProduct extends HTMLElement {
    constructor() {
      super();
      if (this.querySelector("a")) {
        this.init();
      }
    }

    modalFunctions() {
      const options = document.querySelectorAll(
        "#modal-common-as-em-0010 .as-em-0010-label",
      );

      //Change ATC id on option click
      options.forEach((option) => {
        option.addEventListener("click", () => {
          const container = option.closest(".as-em-0010-modal-form");
          const id = option.querySelector("input").getAttribute("value");

          const atc = container.querySelector(
            '.shopify-product-form input[name="id"]',
          );
          atc.setAttribute("value", id);
        });
      });

      //After ATC open cart and reload
      if (this.quickViewModal.querySelector("[data-js-product-form]")) {
        this.quickViewModal
          .querySelector("[data-js-product-form]")
          .addEventListener("add-to-cart", () => {
            document
              .getElementById("site-cart-sidebar")
              ?.scrollTo({ top: 0, behavior: "smooth" });
            this.quickViewModal.hide();

            window.refreshCart();
          });
      }
    }

    init() {
      this.quickViewModal = null;
      this.querySelector("a").addEventListener("keydown", (e) => {
        if (e.keyCode == window.KEYCODES.RETURN) {
          window.lastFocusedElm = this.querySelector("a");
        }
      });
      this.querySelector("a").addEventListener("click", (e) => {
        e.preventDefault();

        if (!this.quickViewModal) {
          const target = e.currentTarget;

          target.classList.add("working");

          //Get html
          const variantDataElement = this.closest(
            ".product-item",
          ).querySelector(".as-em-0010-modal-form");

          this.quickViewModal = document.querySelector(
            "#modal-common-as-em-0010",
          );

          document.body.appendChild(this.quickViewModal);
          this.quickViewModal.querySelector(
            ".em-as-0010-modal-content",
          ).innerHTML = variantDataElement.outerHTML;

          this.modalFunctions();

          if (!window.productPageScripts) {
            const scripts = this.quickViewModal.querySelectorAll("script");
            scripts.forEach((elm) => {
              const script = document.createElement("script");
              script.src = elm.src;
              document.body.append(script);
              window.productPageScripts = true;
            });
          }

          setTimeout(() => {
            this.quickViewModal.show();
            target.classList.remove("working");
          }, 250);
        } else {
          this.quickViewModal.show();
        }
      });
    }
  }

  if (typeof customElements.get("quick-view-product-as") == "undefined") {
    customElements.define("quick-view-product-as", QuickViewProduct);
  }
}